import { useState } from 'react';
import { RecordCount } from 'components/RecordCount';
import { Title } from 'components/Title';

export default function HomePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="HomePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Home"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
            </div>
        </div>
    </div>
</section>
<section className="page-section mb-3" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col-3 comp-grid" >
                <RecordCount title="Listino Gomme"  icon="pi pi-truck" apiPath="components_data/getcount_listinogomme" link={`/gomme`} cardClass="bg-blue-100 text-blue-800" avatarClass="bg-blue-600 text-blue-100"   />
            </div>
            <div className="col-3 comp-grid" >
                <RecordCount title="Prezzi disponibili"  icon="pi pi-euro" apiPath="components_data/getcount_prezzidisponibili" link={`/gomme`} cardClass="bg-blue-100 text-blue-800" avatarClass="bg-blue-600 text-blue-100"   />
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
